import {
  ADMIN_RECEIVABLES_LOCATION,
  AdminHeader,
  Div,
  ReceivablesFilter,
  SearchInput,
  handleSetUrlSearchParams,
} from '@vgrubs/components';
import { useState } from 'react';
import { generatePath } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ReceivablesOverview } from './components/ReceivablesOverview';

/**
 * What locations owe vGrubs.
 *
 * Admin and support both read it. Search and the list's filter live in the
 * URL so a link lands on the same view.
 */
export const Receivables = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const listFilter = (searchParams.get('filter') as ReceivablesFilter) || 'all';
  const [search, setSearch] = useState(searchParams.get('query') || '');

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    handleSetUrlSearchParams('query', event.target.value, setSearchParams);
  };

  const locationPath = (locationId: number) =>
    generatePath(ADMIN_RECEIVABLES_LOCATION, {
      locationId: String(locationId),
    });

  return (
    <>
      <AdminHeader title="Outstanding Balances">
        <SearchInput
          value={search}
          maxWidth="300px"
          maxWidthSM="130px"
          placeholder="Search"
          onChange={onSearchChange}
        />
      </AdminHeader>

      <Div $m="32px 0 0" $mSM="20px 0 0">
        <ReceivablesOverview
          filter={listFilter}
          onFilterChange={(value) =>
            handleSetUrlSearchParams('filter', value, setSearchParams)
          }
          search={search.trim().toLowerCase()}
          locationPath={(row) => locationPath(row.locationId)}
        />
      </Div>
    </>
  );
};
